import React from "react";
import Navbar from "../features/Navbar/Navbar";
import MyOrder from "../features/user/component/MyOrder";

export default function MyOrderPage() {
  return (
    <>
      <Navbar></Navbar>
      <MyOrder></MyOrder>
    </>
  );
}
